export const faviconUrl = (siteUrl: string): string => {
  const host = new URL(siteUrl).host;
  return `https://www.google.com/s2/favicons?domain=${host}&sz=32`;
};
